import { render, staticRenderFns } from "./ASTPreExam.vue?vue&type=template&id=0772ce71&scoped=true&lang=pug&"
import script from "./ASTPreExam.vue?vue&type=script&lang=js&"
export * from "./ASTPreExam.vue?vue&type=script&lang=js&"
import style0 from "./ASTPreExam.vue?vue&type=style&index=0&id=0772ce71&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0772ce71",
  null
  
)

export default component.exports